import React from 'react'
import { Box, Button, Grid, styled, Switch, Typography } from '@mui/material'
import TuneIcon from '@mui/icons-material/Tune'
import { LoadingContainer } from '../LoadingContainer'
import { PoweredBy } from '../PoweredBy'
import { ReactComponent as FaceSvg } from '../face.svg'

const Container = styled(LoadingContainer)({
    color: 'white',
    padding: '2rem 2.5rem',
    overflow: 'auto',
})

const FaceIcon = styled(FaceSvg)({
    width: '5rem',
    height: '5rem',
    transform: 'rotate(180deg)',
})

const StepRow = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: '0.6rem',
    marginBottom: '0.25rem',
})

const InlineIcon = styled(Box)({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '2px solid white',
    borderRadius: 6,
    padding: '2px 3px',
    verticalAlign: 'middle',
})

const TryAgainButton = styled(Button)({
    marginTop: '0.5rem',
    backgroundColor: 'white',
    color: '#1d2059',
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 700,
    fontSize: '1rem',
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
    borderRadius: 8,
    padding: '10px 28px',
    '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
    },
})

const font = { fontFamily: 'Montserrat, sans-serif' }

function PermissionsAndroid() {
    return (
        <Container>
            <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="flex-start"
                sx={{ minHeight: '100%', pb: '80px' }}
            >
                <Grid item sx={{ mb: 2 }}>
                    <FaceIcon />
                </Grid>

                <Grid item sx={{ mb: 3 }}>
                    <Typography variant="h5" sx={{ ...font, fontWeight: 700 }}>
                        Your camera may be blocked.
                    </Typography>
                </Grid>

                <Grid item sx={{ mb: 2.5 }}>
                    <Typography variant="h6" sx={{ ...font, fontWeight: 700 }}>
                        To fix this in Chrome:
                    </Typography>
                </Grid>

                <Grid item sx={{ mb: 2.5, pl: 1 }}>
                    <StepRow>
                        <Typography variant="body1" sx={font}>Tap</Typography>
                        <InlineIcon>
                            <TuneIcon sx={{ fontSize: '1.3rem' }} />
                        </InlineIcon>
                        <Typography variant="body1" sx={font}>to the left of the URL</Typography>
                    </StepRow>
                </Grid>

                <Grid item sx={{ mb: 2.5, pl: 1 }}>
                    <Typography variant="body1" sx={{ ...font, lineHeight: 1.6 }}>
                        Then tap Permissions{'\n'}
                        Camera blocked
                    </Typography>
                </Grid>

                <Grid item sx={{ mb: 3, pl: 1 }}>
                    <StepRow>
                        <Typography variant="body1" sx={font}>Then toggle on</Typography>
                        <Switch
                            checked
                            size="small"
                            sx={{
                                pointerEvents: 'none',
                                '& .MuiSwitch-switchBase.Mui-checked': { color: 'white' },
                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                    backgroundColor: 'white',
                                    opacity: 0.7,
                                },
                            }}
                        />
                        <Typography variant="body1" sx={font}>Permissions</Typography>
                    </StepRow>
                </Grid>

                <Grid item sx={{ mb: 2 }}>
                    <Typography variant="h6" sx={{ ...font, fontWeight: 700 }}>
                        Then tap try again...
                    </Typography>
                </Grid>

                <Grid item>
                    <TryAgainButton onClick={() => window.location.reload()}>
                        Try Again
                    </TryAgainButton>
                </Grid>
            </Grid>
            <PoweredBy />
        </Container>
    )
}

export { PermissionsAndroid }
